/* Psí obleky — theme.js (vanilla, no deps) */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    return Math.round(cents / 100).toLocaleString("cs-CZ") + " Kč";
  };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---- header stuck ---- */
  function header() {
    var h = $(".site-header"); if (!h) return;
    var on = function () { h.classList.toggle("is-stuck", window.scrollY > 8); };
    on(); window.addEventListener("scroll", on, { passive: true });
  }

  /* ---- mobile drawer ---- */
  function drawer() {
    var d = $("#drawer"); if (!d) return;
    var open = $("[data-drawer-open]"), close = $("[data-drawer-close]"), scrim = $(".drawer__scrim", d);
    function set(on) { d.classList.toggle("is-open", on); document.body.style.overflow = on ? "hidden" : ""; }
    open && open.addEventListener("click", function () { set(true); });
    close && close.addEventListener("click", function () { set(false); });
    scrim && scrim.addEventListener("click", function () { set(false); });
    $$(".drawer__nav a", d).forEach(function (a) { a.addEventListener("click", function () { set(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
  }

  /* ---- reveal on scroll ---- */
  function reveal() {
    var els = $$("[data-reveal]");
    if (!("IntersectionObserver" in window) || !els.length) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target, delay = parseInt(el.getAttribute("data-reveal") || "0", 10);
          setTimeout(function () { el.classList.add("is-in"); }, delay);
          io.unobserve(el);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- marquee: duplicate track for seamless loop ---- */
  function marquee() {
    $$(".strip__track").forEach(function (t) {
      if (t.dataset.dup) return; t.dataset.dup = "1";
      t.innerHTML = t.innerHTML + t.innerHTML;
    });
  }

  /* ---- FAQ accordion ---- */
  function faq() {
    $$(".faq__q").forEach(function (q) {
      q.addEventListener("click", function () {
        var item = q.closest(".faq__i"), a = $(".faq__a", item), open = item.classList.contains("is-open");
        item.classList.toggle("is-open", !open);
        a.style.maxHeight = open ? "0px" : a.scrollHeight + "px";
      });
    });
  }

  /* ---- quantity steppers ---- */
  function qty() {
    $$("[data-qty]").forEach(function (w) {
      var input = $("input", w);
      $$("[data-qty-btn]", w).forEach(function (b) {
        b.addEventListener("click", function () {
          var step = b.getAttribute("data-qty-btn") === "up" ? 1 : -1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---- PDP gallery ---- */
  function gallery() {
    var g = $("[data-gallery]"); if (!g) return;
    var main = $("[data-gallery-main]", g);
    $$("[data-gallery-thumb]", g).forEach(function (t) {
      t.addEventListener("click", function () {
        $$("[data-gallery-thumb]", g).forEach(function (x) { x.setAttribute("aria-current", "false"); });
        t.setAttribute("aria-current", "true");
        var key = t.getAttribute("data-media");
        $$("[data-media-item]", main).forEach(function (m) {
          m.toggleAttribute("hidden", m.getAttribute("data-media-item") !== key);
        });
      });
    });
  }

  /* ---- variant selection ---- */
  function variants() {
    var form = $("[data-product-form]"); if (!form) return;
    var data = window.__PRODUCT__; if (!data) return;
    var selected = {};
    function resolve() {
      var match = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      }) || data.variants[0];
      var idInput = $("[name='id']", form); if (idInput) idInput.value = match.id;
      $$("[data-price-now]").forEach(function (n) { n.textContent = money(match.price); });
      var atc = $("[data-atc]", form);
      if (atc) {
        atc.disabled = !match.available;
        var lab = $("[data-atc-label]", atc);
        if (lab) lab.textContent = match.available ? atc.getAttribute("data-label-add") : atc.getAttribute("data-label-soldout");
      }
    }
    $$("[data-opt]", form).forEach(function (group) {
      var idx = parseInt(group.getAttribute("data-opt"), 10);
      selected[idx] = group.getAttribute("data-default");
      $$("input", group).forEach(function (input) {
        if (input.checked) selected[idx] = input.value;
        input.addEventListener("change", function () { selected[idx] = input.value; resolve(); });
      });
    });
    resolve();
  }

  /* ---- sticky ATC ---- */
  function stickyAtc() {
    var bar = $("[data-sticky-bar]"), anchor = $("[data-atc]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (ents) {
      bar.toggleAttribute("data-show", !ents[0].isIntersecting);
    }, { rootMargin: "-90px 0px 0px 0px" });
    io.observe(anchor);
    var sb = $("[data-sticky-add]", bar);
    if (sb) sb.addEventListener("click", function () { anchor.click(); });
  }

  /* ---- add to cart (AJAX) ---- */
  function cart() {
    $$("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        if (!window.Shopify || !window.Shopify.routes) return;
        e.preventDefault();
        var btn = $("[data-atc]", form), label = btn && $("[data-atc-label]", btn), prev = label && label.textContent;
        if (btn) { btn.disabled = true; if (label) label.textContent = "Přidávám…"; }
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: +$("[name='id']", form).value, quantity: +($("[name='quantity']", form) || {}).value || 1 }] })
        }).then(function (r) { return r.json(); }).then(function () {
          return fetch(window.Shopify.routes.root + "cart.js").then(function (r) { return r.json(); });
        }).then(function (c) {
          $$("[data-cart-count]").forEach(function (b) { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
          if (label) label.textContent = "Přidáno do košíku";
          setTimeout(function () { window.location.href = window.Shopify.routes.root + "cart"; }, 550);
        }).catch(function () { if (btn) { btn.disabled = false; if (label) label.textContent = prev; } });
      });
    });
  }

  /* ---- cart page qty auto-submit ---- */
  function cartPage() {
    var form = $("[data-cart-form]"); if (!form) return;
    $$("[data-cart-qty]", form).forEach(function (inp) {
      inp.addEventListener("change", function () {
        if ((parseInt(inp.value, 10) || 0) < 0) inp.value = 0;
        form.submit();
      });
    });
  }

  /* ---- cookie banner ---- */
  function cookies() {
    var c = $("#cookie"); if (!c) return;
    if (store.get("po_cookie_ok", false)) return;
    setTimeout(function () { c.classList.add("is-in"); }, 1200);
    $$("[data-cookie-accept]", c).forEach(function (b) {
      b.addEventListener("click", function () { store.set("po_cookie_ok", true); c.classList.remove("is-in"); });
    });
  }

  /* ---- newsletter fake submit ---- */
  function forms() {
    $$("[data-news-form]").forEach(function (f) {
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        f.innerHTML = '<p style="margin:0;font-family:var(--serif);font-size:1.3rem;color:#e9c9c2">Děkujeme. Kód na 10 % míří do vaší schránky.</p>';
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    header(); drawer(); reveal(); marquee(); faq(); qty(); gallery();
    variants(); stickyAtc(); cart(); cartPage(); cookies(); forms();
  });
})();
